/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
export type CertificatesDTO = {
    id: string;
    name: string;
    description: string;
    img_url: string;
    certificateCategory: {
        id: string;
        name: string;
        description: string;
        createdAt: string;
        updatedAt: string;
        certificateExamId: string;
    }[];
};

interface CertificatesData {
    certificatesData: CertificatesDTO[];
}
interface CertificatesResponse {
    data?: CertificatesData;
    error?: ApiError;
}

export const getCertificates = async (): Promise<CertificatesResponse> => {
    try {
        const response = await axios.get("/certificate-exam/all");
        return { data: { certificatesData: response.data.data } }; // Fix here: Access `data.data`
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};
